import React from "react";
import Image from "next/image";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import styles from "./acheiver.module.css";
import pic1 from "../../assets/images/home/KATHIRSELVI-1stRank-2025.png";
import pic2 from "../../assets/images/home/HARI-PRIYANKKA-3rd-Rank-2025.png";
import pic3 from "../../assets/images/home/KERANAPUK-LYTHIA-4thRank-2025.png";
// import pic6 from "../../assets/images/home/16-AYANJAIN.png";
import Link from "next/link";

const  acheiverslist=[
    { aos: "zoom-in", delay: "200", Image: pic1 , alt: "KATHIRSELVI K", name: "KATHIRSELVI K", dept: "State Rank - 1 (2024)", class:"img-fluid",cont: "Interview Program"},
    { aos: "zoom-in", delay: "300", Image: pic3 , alt: "HARI PRIYANKKA N", name: "HARI PRIYANKKA N", dept: "State Rank - 2 (2024)", class:"img-fluid",cont:(<><span>Interview Program</span></>)},
    { aos: "zoom-in", delay: "400", Image: pic2 , alt: "KERANAPUK LYTHIA P", name: "KERANAPUK LYTHIA P", dept: "State Rank - 4 (2024)", class:"img-fluid",cont: "Interview Program"},

]

const tnpscacheiver=()=>{

   useEffect(() => {
   AOS.init({
     duration: 800,
     easing: "ease-in-out",
     once: true,
     offset: 100,
   });
 }, []);

  
  return(
    <>
      <div className="container">
        <div className="row">
          <div className="col pt-3">
            <div className={styles.scrollparent}>
              {acheiverslist.map((item, index) => (
                <div
                  key={index}
                  className={styles.scrolldiv}
                  data-aos={item.aos}
                  data-aos-delay={item.delay}
                >

                  <span className={styles.redStrip}></span>
                  <div className={styles.imageBox}>
                    <Image
                      src={item.Image}
                      alt={item.alt}
                      className={styles.avatar}
                    />
                  </div>

                  <div className={styles.imageWrapper}>
                    <p>{item.name}</p>
                    <p>{item.name1}</p>
                    <p>{item.dept}</p>

                    <p className={`${styles.acheiverrank} text-center`}>
                      {item.cont}
                    </p>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col pt-5 pb-4 text-center">
            <Link href="/our-achievers" className={styles.viewbuttonalink}>
              <button type="button" className={styles.viewbutton}>
                View All
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
    )
}
export default tnpscacheiver;